import React, { useState, useEffect } from 'react';
import {
  Share2, Activity, Zap, RefreshCw
} from 'lucide-react';
import DashboardLayout from '../layouts/DashboardLayout';
import Toast from '../components/Toast/Toast';
import { getStatsApi } from '../api/home';
import '../styles/home.scss';

function HomeB() {
  const [stats, setStats] = useState({ history: 0, yesterday: 0, today: 0 });
  const [refreshing, setRefreshing] = useState(false);
  const [toast, setToast] = useState({ visible: false, message: '', type: 'error' });
  const formatNumber = (num) => Number(num || 0).toLocaleString();

  useEffect(() => {
    getStatsApi().then(r => { if (r.data) setStats(r.data); }).catch(() => {});
  }, []);

  useEffect(() => {
    const onVisChange = () => {
      if (document.visibilityState !== 'visible') return;
      getStatsApi().then(r => { if (r.data) setStats(r.data); }).catch(() => {});
    };
    document.addEventListener('visibilitychange', onVisChange);
    return () => document.removeEventListener('visibilitychange', onVisChange);
  }, []);

  const handleRefresh = async () => {
    setRefreshing(true);
    await getStatsApi().then(r => { if (r.data) setStats(r.data); }).catch(() => {});
    setRefreshing(false);
  };

  return (
    <DashboardLayout>
      <div className="page-header">
        <h1 className="page-header-title">主页</h1>
        <p className="page-header-desc">查看您的业务数据概览。</p>
        <button className="page-header-refresh" onClick={handleRefresh} disabled={refreshing}>
          <RefreshCw size={16} className={refreshing ? 'spinning' : ''} /> {refreshing ? '刷新中' : '刷新'}
        </button>
      </div>

      {/* 统计卡片 */}
      <div className="stats-row">
        <div className="stat-card"><div className="stat-card-icon"><Share2 size={20} /></div><div className="stat-card-info"><span className="stat-card-label">历史协作次数</span><div className="stat-card-value">{formatNumber(stats.history)}<span>次</span></div></div></div>
        <div className="stat-card"><div className="stat-card-icon"><Activity size={20} /></div><div className="stat-card-info"><span className="stat-card-label">昨日协作次数</span><div className="stat-card-value">{formatNumber(stats.yesterday)}<span>次</span></div></div></div>
        <div className="stat-card"><div className="stat-card-icon"><Zap size={20} /></div><div className="stat-card-info"><span className="stat-card-label">今日协作次数</span><div className="stat-card-value">{formatNumber(stats.today)}<span>次</span></div></div></div>
      </div>

      <Toast visible={toast.visible} message={toast.message} type={toast.type} onClose={() => setToast({ visible: false, message: '', type: 'error' })} />
    </DashboardLayout>
  );
}

export default HomeB;
